import {useFetch} from "../useFetch";
import {LoadTypes} from "../../types/api/guide/loadType.types";
import {loadTypeService} from "../../services/guide/loadType-service";

export const useFetchAllLoadTypes = () => {
    const { isLoading, error, data, refetch } = useFetch<LoadTypes[]>(loadTypeService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
